<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="HCP Request From iDoctor">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Search"
          v-model="searchVal"
          v-debounce="onSearch"
          clearable
          @clear="onSearch"
        />
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
        @sort-change="onSortChange"
        ref="SeTable"
      >
        <el-table-column type="expand" width="20px">
          <template slot-scope="{ row }">
            <div class="table-expand-wrapper">
              <el-row type="flex" justify="space-around">
                <el-col :span="4">
                  <p>Doctor Email</p>
                  <p>{{ row.DoctorEmail }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Doctor Phone</p>
                  <p>{{ row.Phone }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Rep ID</p>
                  <p>{{ row.SrId }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Type</p>
                  <p>{{ row.RequestType }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Reject Reason</p>
                  <p>{{ row.MainRejectReason }}</p>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="4">
                  <p>Hospital / Institution</p>
                  <p>{{ row.Hospital }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Department</p>
                  <p>{{ row.Department }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Rep Name</p>
                  <p>{{ row.SrName }}</p>
                </el-col>
                <el-col :span="4">
                  <p>Product Info</p>
                  <p>{{ row.ProdInfo }}</p>
                </el-col>
                <el-col :span="4">
                  <p>TA</p>
                  <p>{{ row.TA }}</p>
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Id" label="Id" sortable="custom" width="130" />
        <el-table-column
          prop="Title"
          label="Title"
          sortable="custom"
          min-width="185"
        />
        <el-table-column
          prop="DoctorName"
          label="Doctor Name"
          width="145"
          sortable="custom"
        />
        <el-table-column
          prop="TimeSlot"
          label="Time Slot"
          sortable="custom"
          width="150"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="QuestionInfo"
          label="Question From Doctor"
          sortable="custom"
          min-width="230"
        />
        <el-table-column
          prop="CreateDt"
          label="Receive Request Time"
          sortable="custom"
          width="205"
          :formatter="dateFormatter"
        />
        <el-table-column
          label="Operation"
          width="125"
          sortable="custom"
          prop="StatusDesc"
          align="center"
        >
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu
              icon="iconfont icon-more-menu"
              iconSize="18"
              v-if="row.Status == 0"
            >
              <OptionMenuItem
                icon="iconfont icon-approve"
                title="Approve"
                @click="handleApproved(row)"
              />
              <OptionMenuItem
                icon="el-icon-remove-outline"
                title="Reject"
                @click="handleReject(row)"
              />
              <OptionMenuItem
                icon="iconfont icon-share"
                title="Forward"
                @click="handleForward(row)"
              />
            </OptionMenu>
            <span v-else v-text="row.StatusDesc"> </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <ForwardRequestDialog
      :visible.sync="forwardRequestDialogVisible"
      :data.sync="editRow"
      @success="onSuccess"
    />
    <RejectRequestDialog
      :visible.sync="rejectDialogVisible"
      :data.sync="editRow"
      @success="onSuccess"
    />
    <ApprovedRequestDialog
      :visible.sync="approvedDialogVisible"
      :data.sync="editRow"
      :status.sync="forwardStatus"
      @success="onSuccess"
    />
  </div>
</template>

<script>
import moment from "moment";
//import Clipboard from "clipboard";
import ForwardRequestDialog from "../commons/forward-dialog";
import RejectRequestDialog from "./reject-request-dialog";
import ApprovedRequestDialog from "../commons/edit-meeting-dialog";
export default {
  name: "Request-List",
  components: {
    ForwardRequestDialog,
    RejectRequestDialog,
    ApprovedRequestDialog,
  },
  data() {
    return {
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      tableLoading: true,
      searchVal: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: ["IsPending", "CreateDt"],
      orderType: ["ascending", "descending"],
      forwardRequestDialogVisible: false,
      rejectDialogVisible: false,
      approvedDialogVisible: false,
      editRow: null,
      testData: [],
      forwardStatus: "",
    };
  },
  created() {
    this.getRequestList();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getRequestList();
      }
    });
  },
  methods: {
    dateFormatter(row, column, cellValue) {
      return moment(new Date(cellValue)).format(this.dateFormat);
    },
    getRequestList() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      };
      this.axios
        .get(`/meetingReq/getData`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    onSuccess() {
      this.getRequestList();
    },
    onSortChange(column) {
      this.orderBy = [column.prop];
      this.orderType = [column.order];
      this.getRequestList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getRequestList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getRequestList();
    },
    handleApproved(row) {
      this.approvedDialogVisible = true;
      this.editRow = row;
      this.forwardStatus = "approved";
    },
    handleReject(row) {
      this.editRow = row;
      this.rejectDialogVisible = true;
    },
    handleForward(row) {
      this.editRow = row;
      this.forwardRequestDialogVisible = true;
    },
    statusFormatter(status) {
      switch (status) {
        case 0:
          return "待审批";
        case 1:
          return "通过";
        case 2:
          return "拒绝";
      }
    },
    onSearch() {
      this.currentPage = 1;
      this.getRequestList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
